import { noop } from 'mojito/utils';

const NULL_SERVICE = {
    configure: noop,
    subscribe: noop,
    subscribeContainers: noop,
    unsubscribe: noop,
    unsubscribeContainers: noop,
    unsubscribeAllContainers: noop,
    reset: noop,
};

/**
 * Singleton object that receives promotions service config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.Promotions
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
        this.authService = undefined;
    }

    /**
     * Init factory.
     *
     * @function init
     *
     * @param {Mojito.Services.Promotions.types.ServiceFactoryConfig} config - Service factory config object.
     *
     * @memberof Mojito.Services.Promotions.serviceFactory
     */
    init({ service, authService, serviceUrl }) {
        this.service = service || NULL_SERVICE;
        this.authService = authService;
        this.service.configure({ serviceUrl });
        this.authService?.configure({ serviceUrl });
    }

    /**
     * Service getter.
     *
     * @function getService
     *
     * @returns {Mojito.Services.Promotions.AbstractPromotionsService} Promotions service instance.
     *
     * @memberof Mojito.Services.Promotions.serviceFactory
     */
    getService() {
        return this.service;
    }

    /**
     * Auth service getter.
     *
     * @function getAuthService
     *
     * @returns {Mojito.Services.Promotions.AbstractPromotionsService} Abstract promotions service instance.
     *
     * @memberof Mojito.Services.Promotions.serviceFactory
     */
    getAuthService() {
        return this.authService;
    }
}

export default new ServiceFactory();
